



























import { ResultSortCriteria } from '@empathybroker/tsclient-search';

import { UiIconButton } from '../keen-ui';

export default {
  name: 'epb-explain-result-card',
  props: {
    result: {
      type: Object,
      required: true
    },
    collapsed: Boolean
  },
  components: {
    UiIconButton
  },
  computed: {
    resultImageUrl: function (): string {
      return (this.result.imageUrl || this.defaultResultImageUrl);
    },
    mainSortCriteria: function (): ResultSortCriteria {
      return this.result.debug.sort[0];
    },
    sortValueText: function (): string {
      if (!!this.mainSortCriteria) {
        let sortValue = this.mainSortCriteria.value;
        if (!isNaN(Number(sortValue))) {
          sortValue = Number(sortValue);
        }
        return sortValue.toLocaleString(this.$epb.locale);
      }
    }
  },
  data: function () {
    return {
      defaultResultImageUrl: require('../../assets/media/image/image-not-found.svg')
    };
  },
  methods: {
    onResultImageError: function (event): void {
      event.target.src = this.defaultResultImageUrl;
    }
  }
};
